<style lang="scss" scoped>
.base-warp {
  .query-warp {
    padding: 25px 0;
    border-bottom: 1px solid #dedede;
  }
  .table-warp {
    padding-top: 25px;
  }
  .page-warp {
    text-align: right;
    position: relative;
  }
}
.icon {
  width: 15px;
  height: 15px;
}
</style>
<template>
  <div>
    <Divider orientation="center">充值订单</Divider>
    <div class="base-warp">
      <Tabs value="name1">
        <TabPane label="VIP用户订单" name="name1">
          <div class="table-warp">
            <Table
              :loading="loading"
              size="small"
              border
              :columns="replayColumns"
              :data="replayList"
            >
              <template #num="{ row }">
                <span v-if="row.translationBillingMode == 'time'"
                  >{{ new Number((row.num / 60 / 24 / 30).toFixed(0)) }}月</span
                >
                <span v-else>{{ row.num }}字</span>
              </template>
              <template #tranChannelId="{ row }">
                <TranslateChannelLabel :tranChannelId="row.tranChannelId" />
              </template>
              <template #amount="{ row }">
                <strong>{{ (row.amount / 100).toFixed(2) }}</strong>
              </template>
              <template #payInfo="{ row }">
                <img
                  v-if="row.payChannel == 'ALI_NATIVE'"
                  class="icon"
                  src="@/assets/ali.png"
                />
                <img v-else class="icon" src="@/assets/wc.png" />
                <span style="padding-left: 5px">
                  <span v-if="row.payStatus == 'W'" style="color: #ed4014"
                    >待支付</span
                  >
                  <span v-if="row.payStatus == 'P'" style="color: #19be6b"
                    >已支付</span
                  >
                  <span v-if="row.payStatus == 'T'" style="color: #808695"
                    >超时关闭</span
                  >
                  <span v-if="row.payStatus == 'C'" style="color: #808695"
                    >取消支付</span
                  >
                </span>
              </template>
              <template #option="{ row }">
                <a
                  v-if="row.payStatus == 'W'"
                  style="padding-right: 5px"
                  @click="replayFlush(row.id)"
                  >刷新</a
                >
              </template>
            </Table>
          </div>
          <div class="page-warp">
            <Page
              style="margin-top: 25px"
              show-total
              :total="replayPage.total"
              :page-size="replayPage.size"
              v-model="replayPage.num"
              @on-change="replayPageChange"
            />
          </div>
        </TabPane>
        <TabPane label="翻译字符数订单" name="name2"
          ><div class="table-warp">
            <Table
              :loading="loading"
              size="small"
              border
              :columns="columns"
              :data="list"
            >
              <template #num="{ row }">
                <span v-if="row.translationBillingMode == 'time'"
                  >{{ new Number((row.num / 60 / 24 / 30).toFixed(0)) }}月</span
                >
                <span v-else>{{ row.num }}字</span>
              </template>
              <template #tranChannelId="{ row }">
                <TranslateChannelLabel :tranChannelId="row.tranChannelId" />
              </template>
              <template #amount="{ row }">
                <strong>{{ (row.amount / 100).toFixed(2) }}</strong>
              </template>
              <template #payInfo="{ row }">
                <img
                  v-if="row.payChannel == 'ALI_NATIVE'"
                  class="icon"
                  src="@/assets/ali.png"
                />
                <img v-else class="icon" src="@/assets/wc.png" />
                <span style="padding-left: 5px">
                  <span v-if="row.payStatus == 'W'" style="color: #ed4014"
                    >待支付</span
                  >
                  <span v-if="row.payStatus == 'P'" style="color: #19be6b"
                    >已支付</span
                  >
                  <span v-if="row.payStatus == 'T'" style="color: #808695"
                    >超时关闭</span
                  >
                  <span v-if="row.payStatus == 'C'" style="color: #808695"
                    >取消支付</span
                  >
                </span>
              </template>
              <template #option="{ row }">
                <a
                  v-if="row.payStatus == 'W'"
                  style="padding-right: 5px"
                  @click="flush(row.id)"
                  >刷新</a
                >
              </template>
            </Table>
          </div>
          <div class="page-warp">
            <Page
              style="margin-top: 25px"
              show-total
              :total="page.total"
              :page-size="page.size"
              v-model="page.num"
              @on-change="pageChange"
            /></div
        ></TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import orderService from "@/service/order/memberGroup";
export default {
  name: "UserCenterOrder",
  data() {
    return {
      loading: false,
      replayColumns: [
        { title: "订单号", key: "no", width: 230, fixed: "left" },
        { title: "会员类型", key: "memberGroupName", minWidth: 150 },
        // {title: '翻译渠道',slot: 'tranChannelId',minWidth:85},
        // {title: '生效数量',slot: 'num',width:150},
        { title: "订单金额(元)", slot: "amount", width: 150 },
        { title: "支付信息", slot: "payInfo", width: 105, fixed: "left" },
        {
          title: "创建时间",
          key: "createDateTime",
          minWidth: 150,
          fixed: "right",
        },
        { title: "操作", width: 150, fixed: "right", slot: "option" },
      ],
      columns: [
        { title: "订单号", key: "no", width: 230, fixed: "left" },
        { title: "会员类型", key: "memberGroupName", minWidth: 150 },
        { title: "翻译渠道", slot: "tranChannelId", minWidth: 85 },
        { title: "生效数量", slot: "num", width: 150 },
        { title: "订单金额(元)", slot: "amount", width: 150 },
        { title: "支付信息", slot: "payInfo", width: 105, fixed: "left" },
        {
          title: "创建时间",
          key: "createDateTime",
          minWidth: 150,
          fixed: "right",
        },
        { title: "操作", width: 150, fixed: "right", slot: "option" },
      ],
      replayPage: {
        size: 10,
        num: 1,
        total: 0,
      },
      replayList: [],
      page: {
        size: 10,
        num: 1,
        total: 0,
      },
      list: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadData();
      this.loadReplayData();
    },
    async loadData() {
      this.loading = true;
      let params = {
        pageSize: this.page.size,
        pageNum: this.page.num,
      };
      let result = await orderService.page(params);
      this.list = result.rows;
      this.page.total = result.total;
      console.log(result);
      this.loading = false;
    },
    pageChange() {
      this.loadData();
    },
    async flush(orderId) {
      this.loading = true;
      let result = await orderService.flush(orderId);
      if (result) {
        this.loadData();
      }
      this.loading = false;
    },

    async loadReplayData() {
      this.loading = true;
      let params = {
        pageSize: this.page.size,
        pageNum: this.page.num,
      };
      let result = await orderService.replayPage(params);
      this.replayList = result.rows;
      this.replayPage.total = result.total;
      console.log(result);
      this.loading = false;
    },
    replayPageChange() {
      this.loadReplayData();
    },
    async replayFlush(orderId) {
      this.loading = true;
      let result = await orderService.replayFlush(orderId);
      if (result) {
        this.loadReplayData();
      }
      this.loading = false;
    },
  },
};
</script>

